import type { LucideIcon } from 'lucide-react';

import { ToggleGroupItem } from '@nesso/ui/primitives/toggle-group';
import { Tooltip, TooltipContent, TooltipTrigger } from '@nesso/ui/primitives/tooltip';

interface ThemeToggleButtonProps {
    value: string;
    label: string;
    icon: LucideIcon;
    isSelected: boolean;
}

export function UserDropdownThemeToggleButton({
    value,
    label,
    icon: Icon,
    isSelected,
}: ThemeToggleButtonProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <ToggleGroupItem
                    value={value}
                    aria-label={`${label} theme`}
                    className={`text-muted-foreground px-1 py-1.5 min-w-0 w-8 h-9 hover:bg-transparent focus-visible:ring-2 hover:text-muted-foreground data-[state=on]:bg-transparent data-[state=on]:text-muted-foreground ${isSelected ? '!text-primary-icon !bg-primary/30 hover:!text-primary-icon hover:!bg-primary/30' : ''}`}
                >
                    <Icon className="!w-6 !h-6 !shrink-0" />
                </ToggleGroupItem>
            </TooltipTrigger>
            <TooltipContent showArrow={false}>
                <p>{label}</p>
            </TooltipContent>
        </Tooltip>
    );
}
